export default __webpack_public_path__ + "static/media/HDTX_The Invitation of GMS 2022.819931ad.pdf";